import { useMutation } from '@tanstack/react-query';
import Toaster from 'src/app/utilities/helpers/Toaster';
import { parseErrors } from 'src/app/utilities/helpers/errors';
import ApiResponse from 'src/data/api/responses/ApiResponse';
import ApiResponseBody from 'src/data/api/responses/ApiResponseBody';
import EventTicketFile from 'src/data/models/tickets/eventTicketFileWithFileNames';
import ticketLinkImportService from 'src/data/services/ticketLinkImportService';

export const useGetTicketLinkDuplicateTicket = (
    onSuccess?: (result: ApiResponse<ApiResponseBody<EventTicketFile>>) => void
) => {
    return useMutation({
        mutationFn: (importRowId: string) =>
            ticketLinkImportService.getTicketLinkDuplicateTicketId(importRowId),
        onSuccess: (result: ApiResponse<ApiResponseBody<EventTicketFile>>) => {
            onSuccess?.(result);
        },
        onError: (errors) => Toaster.toastErrors(parseErrors(errors)),
    });
};
